function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Information from 'modules/Information';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import validatorRules from './validatorRules.json';
class JoinForm extends FormContainerAbstract {
    componentDidUpdate(prevProps) {
        const { isInProgress } = this.props;
        if (prevProps.isInProgress !== isInProgress) {
            this.setProgressIndicator();
        }
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            const { organization } = this.props;
            const { businessEmail } = validatedValues;
            this.props.onSubmit(organization, businessEmail);
        }
    }
    setProgressIndicator() {
        this.setState({
            isInProgress: this.props.isInProgress
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsx(Button, {
            type: "submit",
            styleModifier: "primary",
            labelMessage: messages.buttons.joinOrganization,
            className: "btn--block btn--filled",
            isDisabled: this.isDisabled,
            isInProgress: this.state.isInProgress
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "businessEmail",
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.email,
                        onChange: (input)=>this.onSetValue(input)
                    })
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
        this.state = {
            isInProgress: false
        };
        const { email } = props.information;
        props.onSetFormValues({
            businessEmail: email
        });
    }
}
_define_property(JoinForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    organization: shapes.organization,
    // Explicit actions
    onClose: PropTypes.func,
    // Implicit props
    information: PropTypes.shape({
        email: PropTypes.string.isRequired
    })
}));
const mapStateToProps = (state)=>({
        information: Information.selectors.information(state),
        formValues: App.selectors.formSelector(constants.JOIN_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.JOIN_FORM;
    return {
        onSubmit: (organization, businessEmail)=>dispatch(actions.joinOrganization(organization, businessEmail)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedJoinForm = connect(mapStateToProps, mapDispatchToProps)(JoinForm);
export default ConnectedJoinForm;
